<template>
    <div>       
        <div :class="[label.length > 0 ? 'form-group' : '']">
            <label v-if="label.length > 0" class="typo__label">{{label}}</label>
            <multiselect 
                :value="selected" v-on:input="update_selected($event)"
                :options="groups" 
                :multiple="true" 
                :group-values="groupValues" 
                :group-label="groupLabel" 
                :group-select="groupValues.length > 0"
                :placeholder="placeholder" 
                :track-by="trackBy" 
                :label="trackLabel"
                :internalValue ="selected.id"
                :visibleValues="selected.name"
                :allow-empty="true"
            ></multiselect>
            <input type="hidden" :name="name" :value="JSON.stringify(selected)" >
           <!--  <pre class="language-json"><code>{{ selected  }}</code></pre> -->  
        </div>
    </div>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    export default {
        components: { Multiselect },
        props: {
            label: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: 'assignAdmin'
            },
            selectOptions: {
                type: Array
            },
            value: {
                type: Array|String
            },
            groupValues: {
                type: String,
                default: ''
            },
            groupLabel: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: 'Select any'
            },
            trackBy: {
                type: String,
                default: 'id'
            },
            trackLabel: {
                type: String,
                default: 'name'
            },
            search: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                groups: this.selectOptions,            
                selected: this.value !== undefined && this.value !== null && this.value.constructor === Array ? this.value : (this.value !== undefined && this.value !== null && this.value.length > 0 ? JSON.parse(this.value) : []) ,
            }
        },
        mounted() {  
        },
        methods: {
            update_selected: function(value){
                this.selected = value;
                if(this.search){
                    if(this.selected.length == 0){
                        this.$emit('input','');
                    } else {
                        this.$emit('input',JSON.stringify(this.selected));
                    }
                } else {
                    this.$emit('input',this.selected);
                }
                this.$emit('change',this.selected);
            },
        }
    }
    
</script>

<style>
    .multiselect__option--disabled {
        background: #ffffcc !important;
        color: #000 !important;
        font-weight: 600!important;
        font-style: italic;
        cursor: text;
        pointer-events: none;
    }
    .multiselect__tags {
        min-height: 30px;
        height: calc(1.4em + 0.75rem + 2px);
        padding: 0.375rem 0.75rem;
        border-radius: 0.25rem;
        border: 1px solid #ced4da;
    }
</style>


